// Books Context — Public API (client-safe)
// For server-only services/repositories, use '@/contexts/illustrations/server'

// Types
export type {
  Illustration,
  IllustrationPage,
  IllustrationCharacterReference,
  StoryAnalysisResult,
  CharacterDecision,
} from './types';

export type {
  IllustrationStyle,
  IllustrationFormat,
  IllustrationStatus,
  IllustrationPageImageStatus,
  IllustrationGenerationPhase,
} from './types';

// Components
export { IllustrationLibrary } from './components/BookLibrary';
export { CoverReferenceSelector } from './components/CoverReferenceSelector';
export { GenerateImageButton } from './components/GenerateImageButton';
export { IllustrationFavoriteButton } from './components/shared/BookFavoriteButton';

// Actions
export { getIllustrations } from './actions/getBooks';
export { toggleFavorite } from './actions/toggleFavorite';
export { getIllustrationsByStory } from './actions/getBooksByStory';
export { generateCharacterReference } from './actions/generateCharacterReference';
export { generateMissingReferences } from './actions/generateMissingReferences';
export { generateCover } from './actions/generateCover';
export { cancelCoverGeneration } from './actions/cancelCoverGeneration';
export { updateIllustration } from './actions/updateBook';
export { unlinkIllustrationCharacter } from './actions/unlinkBookCharacter';
export { updateCastDescription } from './actions/updateCastDescription';
export { applyCharacterToIllustrationReference } from './actions/applyCharacterToBookReference';
export { generatePage } from './actions/generatePage';
export { retryIllustrationGeneration } from './actions/retryIllustrationGeneration';
export { generateAllPages } from './actions/generateAllPages';
export { deleteIllustration } from './actions/deleteBook';
export { updatePageCharacters, updatePagePrompt, updatePageScene, getPageEditable } from './actions/updatePageDetails';
export { exportIllustrationPdf } from './actions/exportBookPdf';
export { exportIllustrationAsPdf } from './actions/exportPdf';
export { startVideoExport } from './actions/startVideoExport';

// Navigation

// Query Keys
export { illustrationKeys } from './queryKeys';
